import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Selamat datang kembali!");
      nav("/dashboard");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Login gagal");
    } finally { setBusy(false); }
  };

  const google = () => {
    const redirect = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
  };

  return (
    <div className="min-h-screen kt-gradient-hero flex items-center justify-center p-6">
      <div className="w-full max-w-md kt-card p-8">
        <Link to="/" className="flex justify-center mb-4">
          <img src="https://customer-assets-v7afamib.emergentagent.net/job_thesis-mate/artifacts/l29gu6p6_Untitled%20design%20%283%29.png" alt="kawantugas.id" className="h-20 w-auto" />
        </Link>
        <h1 className="serif text-3xl font-bold text-[#0F2922] mb-1">Masuk</h1>
        <p className="text-sm text-slate-600 mb-6">Lanjutkan perjalanan akademikmu.</p>

        <Button variant="outline" className="w-full mb-4 border-slate-300" onClick={google} data-testid="login-google-button">
          <svg width="18" height="18" viewBox="0 0 48 48" className="mr-2"><path fill="#4285F4" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.6 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 8 3l5.7-5.7C33.9 6.1 29.2 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.2-.1-2.3-.4-3.5z"/><path fill="#34A853" d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c3 0 5.8 1.1 8 3l5.7-5.7C33.9 7.1 29.2 5 24 5 16.1 5 9.3 9.4 6.3 14.7z"/><path fill="#FBBC05" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5c-2 1.4-4.5 2.2-7.2 2.2-5.3 0-9.7-3.4-11.3-8.1l-6.5 5C9.2 39.6 16 44 24 44z"/><path fill="#EA4335" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.1 5.8l6.2 5c-.4.4 6.6-4.8 6.6-14.3 0-1.2-.1-2.3-.4-3.5z"/></svg>
          Masuk dengan Google
        </Button>
        <div className="text-xs text-center text-slate-400 mb-4">atau gunakan email</div>

        <form onSubmit={submit} className="space-y-3">
          <div><Label>Email</Label><Input type="email" required value={email} onChange={e=>setEmail(e.target.value)} data-testid="login-email-input" /></div>
          <div><Label>Password</Label><Input type="password" required value={password} onChange={e=>setPassword(e.target.value)} data-testid="login-password-input" /></div>
          <Button type="submit" disabled={busy} className="w-full bg-[#0F2922] hover:bg-[#173E34] text-[#FAFA96]" data-testid="login-submit-button">
            {busy ? "Memuat…" : "Masuk"}
          </Button>
        </form>
        <p className="mt-4 text-sm text-center text-slate-600">Belum punya akun? <Link to="/register" className="text-[#D97706] font-semibold">Daftar</Link></p>
      </div>
    </div>
  );
}
